import { motion } from "framer-motion";
import { Zap, Building2, Lock, Clock, CheckCircle2 } from "lucide-react";

import { Card } from "@/components/ui/card";

// FIN-7 — ComoFuncionaSection
//
// 3 cards numerados explicando o fluxo Open Finance:
//   01 Escolha o banco
//   02 Consentimento oficial
//   03 Sincroniza sozinho
//
// Footer com selo "Tecnologia Pluggy · certificada pelo BACEN".
//
// Renderiza igual em modo dormente e ativo — é educativo, não depende
// de estado de conexões.

const STEPS = [
  {
    n: "01",
    Icon: Building2,
    title: "Escolha o banco",
    desc: "Selecione a instituição e autorize pelo portal seguro do seu próprio banco.",
  },
  {
    n: "02",
    Icon: Lock,
    title: "Consentimento oficial",
    desc: "O banco gera um consentimento criptografado, válido pelo tempo que você definir.",
  },
  {
    n: "03",
    Icon: Clock,
    title: "Sincroniza sozinho",
    desc: "Extrato, faturas e investimentos atualizam em tempo real. Sem digitar nada.",
  },
];

export default function ComoFuncionaSection() {
  return (
    <Card
      variant="elevated"
      className="glass-card p-5 md:p-6"
      data-testid="conexoes-como-funciona"
    >
      {/* Header */}
      <div className="flex items-center gap-2 mb-5">
        <Zap className="w-4 h-4 text-brand-green" aria-hidden="true" />
        <h3 className="text-caption font-bold tracking-[0.18em] uppercase text-foreground-muted">
          Como Funciona
        </h3>
      </div>

      {/* 3 steps */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
        {STEPS.map((step, idx) => (
          <motion.div
            key={step.n}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.4,
              delay: 0.06 * idx,
              ease: [0.2, 0.8, 0.2, 1],
            }}
            className="relative rounded-xl border border-subtle bg-surface-card-hover/40 p-5 hover:border-brand-green/30 hover:bg-brand-green/5 transition-colors duration-fast"
          >
            {/* Big number — texto fantasma no canto direito */}
            <span
              aria-hidden="true"
              className="absolute top-3 right-4 font-display font-bold text-[36px] md:text-[44px] leading-none text-brand-green/15 select-none"
            >
              {step.n}
            </span>

            <div className="w-10 h-10 rounded-lg bg-brand-green/10 border border-brand-green/30 flex items-center justify-center mb-4">
              <step.Icon className="w-5 h-5 text-brand-green" aria-hidden="true" />
            </div>

            <h4 className="font-semibold text-foreground text-base leading-tight mb-1.5">
              {step.title}
            </h4>
            <p className="text-caption text-foreground-muted leading-relaxed">
              {step.desc}
            </p>
          </motion.div>
        ))}
      </div>

      {/* Footer Pluggy + BACEN */}
      <div className="flex items-center justify-center gap-2 mt-6 pt-5 border-t border-subtle">
        <CheckCircle2 className="w-4 h-4 text-brand-green" aria-hidden="true" />
        <span className="text-caption text-foreground-muted">
          Tecnologia <strong className="text-foreground font-semibold">Pluggy</strong> ·
          certificada pelo Banco Central do Brasil
        </span>
      </div>
    </Card>
  );
}
